import React from 'react';

const LazyWinningTicket = React.lazy(() =>
  import(/* webpackChunkName: "WinningTicket" */ './winningTicket')
);

const WinningTicket = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyWinningTicket {...props} />
  </React.Suspense>
);

export default WinningTicket